import { reads } from '@ember/object/computed';
import { Promise } from 'rsvp';
import { computed } from '@ember/object';
import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
import Enum from '@square/dashboard-utilities/utils/enum';
import environment from '@square/environment-utils/environment';
import ClientEncryptedTender from '@square/dashboard-data/models/squareup/panhandler/service/client-encrypted-tender';
import Panhandler from '@square/dashboard-data/utils/panhandler';
import UnencryptedCardInformation from '@square/dashboard-data/models/squareup/simple-instrument-store/api/unencrypted-card-information';
const {
  isProduction
} = environment();
export const CardLinkingEntryMethod = new Enum('UNKNOWN_ENTRY_METHOD', 'SWIPED', 'KEYED', 'EMV', 'CONTACTLESS', 'PAYMENT_TOKEN');
export const CardInformation = ProtoBaseModel.extend({
  // exactly one of these should ever be populated in a CardInformation object
  unencryptedCardInformation: attr(UnencryptedCardInformation),
  encryptedCardInformation: attr(ClientEncryptedTender),
  cardholderName: attr(String),
  entryMethod: attr(CardLinkingEntryMethod),
  pan: reads('unencryptedCardInformation.pan'),
  expirationDate: reads('unencryptedCardInformation.expirationDate'),
  securityCode: reads('unencryptedCardInformation.securityCode'),
  postalCode: reads('unencryptedCardInformation.postalCode'),
  panhandler: computed('expirationDate.{twoDigitMonth,twoDigitYear}', 'pan', 'postalCode', 'securityCode', function () {
    return new Panhandler(this.pan, this.get('expirationDate.twoDigitMonth'), this.get('expirationDate.twoDigitYear'), this.securityCode, this.postalCode, isProduction);
  }),
  encrypt() {
    // CardInformation#encrypt returns a promise and Panhandler#encrypt takes in a callback, so we wrap a promise around Panhandler#encrypt
    return new Promise(resolve => {
      return this.panhandler.encrypt(ciphertext => {
        return resolve(CardInformation.create({
          cardholderName: this.cardholderName,
          entryMethod: CardLinkingEntryMethod.KEYED,
          encryptedCardInformation: ClientEncryptedTender.createFromCiphertext(ciphertext)
        }));
      });
    });
  }
});